export enum LOCALIZATION_LOCALE {
  DE = 'de-DE',
  CZ = 'cs-CZ',
  FR = 'fr-FR',
  US = 'en-US',
  VN = 'vi-VN',
}
